/** Explicitly admitted, inactive history; not every imported/live booking. */
export interface ArchivedDriveShareTripLike {
  migration_source?: unknown;
  source_id?: unknown;
  is_active?: unknown;
  status?: unknown;
  platform_origin?: unknown;
}

const TERMINAL = new Set(["completed", "cancelled", "declined", "expired"]);

function validSourceId(id: unknown): boolean {
  return typeof id === "number"
    ? Number.isSafeInteger(id) && id > 0
    : typeof id === "string" && /^\d+$/.test(id) && !/^0+$/.test(id);
}

export function isArchivedDriveShareTrip(
  trip: ArchivedDriveShareTripLike | null | undefined,
): boolean {
  if (!trip || trip.migration_source !== "driveshare" || trip.is_active !== false
      || typeof trip.status !== "string" || !TERMINAL.has(trip.status)) return false;
  return validSourceId(trip.source_id);
}

/** Read/display only. Public views omit the physical migration marker.
 * This deliberately conservative presentation gate must NEVER authorize an
 * operational exclusion, payout, migration or status change.
 */
export function isInactiveDriveShareHistoryForDisplay(trip: ArchivedDriveShareTripLike): boolean {
  return trip.is_active === false && validSourceId(trip.source_id)
    && typeof trip.status === "string" && TERMINAL.has(trip.status)
    && ["DS", "ds", "driveshare"].includes(String(trip.platform_origin));
}

/** Retain the previous completed-US-import reader, extending explicit archives. */
export function shouldReadHistoricalHostPayout(
  trip: ArchivedDriveShareTripLike,
  context: { imported: boolean; countryCode?: string | null },
): boolean {
  return isArchivedDriveShareTrip(trip)
    || isInactiveDriveShareHistoryForDisplay(trip)
    || (context.imported && trip.status === "completed" && context.countryCode === "US");
}
